import { SeuNavigationOutletKey, SeuOutletsConfig } from '@seu-types';

export const SEU_OUTLETS: {
  [key in SeuNavigationOutletKey]: SeuOutletsConfig;
} = {
  ['offer-details']: { detail: 'offer-details' },
  ['global-values']: {
    overview: 'global-values',
    detail: 'global-values',
  },
  ['operating-conditions']: {
    overview: 'operating-conditions',
    detail: 'operating-conditions',
  },
  ['components']: { overview: 'components', detail: 'components' },
};
